import * as types from "./actionType";

const initialState = {
  documentUpload: null,
  documentUploadStatus: false,
  documentRead: [],
  documentReadStatus: false,
  binaryDocument: null,
  documentGalleryUpload: null,
  documentGalleryUploadStatus: false,
  documentGalleryRead: [],
  documentGalleryReadStatus: false,
  binaryGalleryDocument: null,
  documentVideoUpload: null,
  documentVideoUploadStatus: false,
  documentVideoRead: [],
  documentVideoReadStatus: false,
  binaryVideoDocument: null,
};

function uploadImageReducer(state = initialState, action) {
  switch (action.type) {
    case types.UPLOAD_URL:
      return {
        ...state,
        documentUploadStatus: true,
        documentUpload: null,
      };
    case types.UPLOAD_URL_SUCCESS: {
      return {
        ...state,
        documentUploadStatus: false,
        documentUpload: action.payload,
      };
    }
    case types.UPLOAD_URL_FAILED: {
      return {
        ...state,
        documentUploadStatus: false,
        documentUpload: null,
      };
    }

    case types.READ_URL:
      return {
        ...state,
        documentReadStatus: true,
      };
    case types.READ_URL_SUCCESS: {
      return {
        ...state,
        documentReadStatus: false,
        documentRead: action.payload,
      };
    }
    case types.READ_URL_FAILED: {
      return {
        ...state,
        documentReadStatus: false,
        documentRead: [],
      };
    }

    case types.UPLOAD_BINARY_URL:
      return {
        ...state,
        binaryDocument: null,
      };
    case types.UPLOAD_BINARY_URL_SUCCESS: {
      return {
        ...state,
        binaryDocument: action.payload,
      };
    }
    case types.UPLOAD_BINARY_URL_FAILED: {
      return {
        ...state,
        binaryDocument: null,
      };
    }
    case types.UPLOAD_GALLERY_URL:
      return {
        ...state,
        documentGalleryUploadStatus: true,
        documentGalleryUpload: null,
      };
    case types.UPLOAD_GALLERY_URL_SUCCESS: {
      return {
        ...state,
        documentGalleryUploadStatus: false,
        documentGalleryUpload: action.payload,
      };
    }
    case types.UPLOAD_GALLERY_URL_FAILED: {
      return {
        ...state,
        documentGalleryUploadStatus: false,
        documentGalleryUpload: null,
      };
    }

    case types.READ_GALLERY_URL:
      return {
        ...state,
        documentGalleryReadStatus: true,
      };
    case types.READ_GALLERY_URL_SUCCESS: {
      return {
        ...state,
        documentGalleryReadStatus: false,
        documentGalleryRead: action.payload,
      };
    }
    case types.READ_GALLERY_URL_FAILED: {
      return {
        ...state,
        documentGalleryReadStatus: false,
        documentGalleryRead: [],
      };
    }

    case types.UPLOAD_GALLERY_BINARY_URL:
      return {
        ...state,
        binaryGalleryDocument: null,
      };
    case types.UPLOAD_GALLERY_BINARY_URL_SUCCESS: {
      return {
        ...state,
        binaryGalleryDocument: action.payload,
      };
    }
    case types.UPLOAD_GALLERY_BINARY_URL_FAILED: {
      return {
        ...state,
        binaryGalleryDocument: null,
      };
    }
    case types.UPLOAD_VIDEO_URL:
      return {
        ...state,
        documentVideoUploadStatus: true,
        documentVideoUpload: null,
      };
    case types.UPLOAD_VIDEO_URL_SUCCESS: {
      return {
        ...state,
        documentVideoUploadStatus: false,
        documentVideoUpload: action.payload,
      };
    }
    case types.UPLOAD_VIDEO_URL_FAILED: {
      return {
        ...state,
        documentVideoUploadStatus: false,
        documentVideoUpload: null,
      };
    }

    case types.READ_VIDEO_URL:
      return {
        ...state,
        documentVideoReadStatus: true,
      };
    case types.READ_VIDEO_URL_SUCCESS: {
      return {
        ...state,
        documentVideoReadStatus: false,
        documentVideoRead: action.payload,
      };
    }
    case types.READ_VIDEO_URL_FAILED: {
      return {
        ...state,
        documentVideoReadStatus: false,
        documentVideoRead: [],
      };
    }

    case types.UPLOAD_VIDEO_BINARY_URL:
      return {
        ...state,
        binaryVideoDocument: null,
      };
    case types.UPLOAD_VIDEO_BINARY_URL_SUCCESS: {
      return {
        ...state,
        binaryVideoDocument: action.payload,
      };
    }
    case types.UPLOAD_VIDEO_BINARY_URL_FAILED: {
      return {
        ...state,
        binaryVideoDocument: null,
      };
    }

    case types.CLEAR_PREVIOUS_REDUCERS:
      return {
        documentUpload: null,
        documentRead: [],
        binaryDocument: null,
        documentGalleryUpload: null,
        documentGalleryRead: [],
        binaryGalleryDocument: null,
        documentVideoUpload: null,
        documentVideoRead: [],
        binaryVideoDocument: null,
      };

    default:
      return state;
  }
}

export default uploadImageReducer;